import { render, staticRenderFns } from "./LocationInfo.vue?vue&type=template&id=1f8a54b8&lang=pug"
import script from "./LocationInfo.vue?vue&type=script&lang=coffee"
export * from "./LocationInfo.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports